import { tableAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import textStyles from "../../../../theme/foundations/generated/textStyles";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    ...parts.keys,
    "notFoundContainer",
    "sortIconsContainer",
    "tableContainer",
]);
const textHeaderStyle = textStyles.body.medium;
const textRowsStyle = textStyles.body.mediumBold;
const variants = {
    default: definePartsStyle({
        thead: {
            backgroundColor: "semantic.foreground.primary",
            th: Object.assign({ height: "12", px: "4", py: "3", color: "semantic.text.inverse" }, textHeaderStyle),
        },
        tbody: {
            tr: {
                boxSizing: "border-box",
                minHeight: "14",
                "&:nth-of-type(odd):not(.ds-row-expansion):not(.ds-row-expansion *)": {
                    backgroundColor: "semantic.surface.1",
                    "th, td": Object.assign({ px: "4", borderBottomWidth: "1px", borderColor: "semantic.border.tertiary", color: "semantic.text.primary" }, textRowsStyle),
                },
                "&:nth-of-type(even):not(.ds-row-expansion):not(.ds-row-expansion *)": {
                    backgroundColor: "semantic.surface.1",
                    "th, td": Object.assign({ px: "4", borderBottomWidth: "1px", borderColor: "semantic.border.tertiary", color: "semantic.text.primary" }, textRowsStyle),
                },
                "&.ds-selected-row:not(.ds-row-expansion):not(.ds-row-expansion *)": {
                    backgroundColor: "semantic.cta.secondaryHoverStrong",
                },
                "&.ds-row-expansion > td": {
                    padding: 0,
                },
                td: {
                    minHeight: "14",
                },
                "td.datatable-td-actions": {
                    paddingBottom: 0,
                    paddingTop: 0,
                },
                th: {
                    minHeight: "14",
                },
            },
        },
        notFoundContainer: {
            pt: "4",
            pb: "12",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "semantic.background.info",
        },
        sortIconsContainer: {
            color: "core.white",
            pl: "2",
        },
    }),
    subTable: definePartsStyle({
        tbody: {
            backgroundColor: "semantic.background.info",
            boxSizing: "border-box",
            borderColor: "semantic.border.tertiary",
            borderBottomWidth: "2px",
            tr: {
                boxSizing: "border-box",
                minHeight: "10",
                backgroundColor: "semantic.background.info",
            },
        },
    }),
    infinite: definePartsStyle(({ windowScroll }) => ({
        tableContainer: {
            width: "100%",
            position: "relative",
        },
        table: {
            tableLayout: "fixed",
            width: "100%",
        },
        thead: Object.assign(Object.assign({}, (!windowScroll ? { position: "sticky", top: 0 } : {})), { zIndex: 2, th: Object.assign({ backgroundColor: "semantic.foreground.primary", height: "12", px: "4", py: "3", color: "semantic.text.inverse" }, textHeaderStyle) }),
        tbody: {
            tr: {
                td: {
                    backgroundColor: "semantic.surface.1",
                },
                boxSizing: "border-box",
                height: "14",
                "th, td": Object.assign({ px: "4", borderBottomWidth: "1px", borderColor: "semantic.border.tertiary", color: "semantic.text.primary" }, textRowsStyle),
                "&:nth-of-type(odd):not(.ds-row-expansion)": {
                    backgroundColor: "none",
                },
                "&:nth-of-type(even):not(.ds-row-expansion)": {
                    backgroundColor: "none",
                },
                "&.ds-selected-row:not(.ds-row-expansion)": {
                    backgroundColor: "semantic.cta.secondaryHover",
                },
            },
        },
        notFoundContainer: {
            pt: "4",
            pb: "12",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "semantic.background.info",
        },
        sortIconsContainer: {
            color: "core.white",
            pl: "2",
        },
    })),
};
const dataTableTheme = defineMultiStyleConfig({
    variants,
    defaultProps: {
        variant: "default",
    },
});
export default dataTableTheme;
//# sourceMappingURL=DataTable.default.js.map